import { Wallet } from '@mercadopago/sdk-react'
import React from 'react'

const MercadoPagoButton: React.FC<{ preferenceId: string; setRenderizado: (r: boolean) => void }> = ({
  preferenceId,
  setRenderizado
}) => {
  return <Wallet initialization={{ preferenceId }} locale="es-AR" onReady={() => setRenderizado(true)} />
}

export default MercadoPagoButton
